import BaseModal from 'ext-ui/components/BaseModal/BaseModal'
import React from 'react'
import * as style from 'src/app/BulkInvite/shells/FullscreenModalShell.style'

interface FullscreenModalShellProps {
  onClose: () => void
  ariaLabel: string
}

/** Near-full-viewport modal presentation (BaseModal `fullscreen` variant). */
const FullscreenModalShell: React.FC<
  React.PropsWithChildren<FullscreenModalShellProps>
> = ({ onClose, ariaLabel, children }) => (
  <BaseModal
    isOpen
    onClose={onClose}
    variant="fullscreen"
    shouldCloseOnEsc
    shouldCloseOnOverlayClick={false}
    aria-label={ariaLabel}
  >
    <div css={style.container}>{children}</div>
  </BaseModal>
)

export default FullscreenModalShell
